<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/blog">Блог</router-link>
          <span></span>
          <h1>Создание статьи</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="block_flex">
          <div class="left">
            <div class="folder radius">
              <div class="column caption">
                <p>Основные настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <form-input name="title"></form-input>
                  <form-input name="url"></form-input>
                  <form-drop-down title="title" name="author_id" :id="parentId.authors"
                                  :url="apiUrls.content"></form-drop-down>
                  <div class="list">
                    <p>Настройки отображения</p>
                    <div class="checkbox-group">
                      <checkbox name="show_author"></checkbox>
                      <checkbox name="show_date"></checkbox>
                    </div>
                  </div>
                  <form-drop-down title="title" name="parent_id" :id="parentId.blog"
                                  :url="apiUrls.content"></form-drop-down>
                  <form-file use-case="cover" name="img"></form-file>
                  <form-input name="seo_alt"></form-input>
                  <form-text-area name="subtext"></form-text-area>
                </div>
              </div>

            </div>
          </div>
          <div class="right">
            <div class="folder radius">
              <div class="column caption">
                <p>СЕО настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <form-input name="seo_title"></form-input>
                  <form-text-area name="seo_desc"></form-text-area>
                  <form-text-area name="seo_key"></form-text-area>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="folder radius">
          <div class="column caption">
            <p>Текст статьи</p>
          </div>
          <div class="column">
            <div class="content">
              <form-text-editor name="text" editor-id="editor"></form-text-editor>
              <add-image v-if="isLoaded"/>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onAddItem">Сохранить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import Checkbox from '@/components/create-form/Checkbox'
  import AddImage from '@/components/edit-form/AddImage'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    data: function () {
      return {
        editorInstance: '',
        isLoaded: false,
        text: '',
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'textContent',
        'fields'
      ]),
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions',
        'setUrl'
      ]),
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
          .then(() => {
          this.$router.push('/blog')
        })
      },
    },
    created () {
      this.setUrl(this.apiUrls.content)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название статьи',
          errorId: null,
          errors: {empty: 'Введите название статьи'},
          tabId: 0
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Alt',
          errorId: null,
          errors: {empty: 'Напишите alt для картинки'},
          tabId: 0,
          isNullable: true
        },
        url: {
          value: '',
          parameterName: 'url',
          name: 'Ссылка',
          errorId: null,
          errors: {unique: 'Ссылка должна быть уникальной'},
          tabId: 0,
          isNullable: true
        },
        author_id: {
          value: '',
          parameterName: 'author_id',
          name: 'Автор',
          errorId: null,
          errors: {empty: 'Выберите автора'},
          tabId: 0,
          isNullable: true
        },
        parent_id: {
          value: '',
          parameterName: 'parent_id',
          name: 'Категория',
          errorId: null,
          errors: {empty: 'Выберите категорию'},
          tabId: 0,
        },
        show_author: {
          value: true,
          parameterName: 'show_author',
          name: 'Отображать автора',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        show_date: {
          value: true,
          parameterName: 'show_date',
          name: 'Отображать дату',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        subtext: {
          value: '',
          parameterName: 'subtext',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Введите краткое описание'},
          tabId: 0,
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0,
          isNullable: true
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
        content_id: {
          value: this.$store.state.parentId.blog,
          parameterName: 'content_id',
          errorId: null,
          isNullable: true,
        },
        object: {
          value: {},
          parameterName: 'object',
          errorId: null,
          isNullable: true,
        }
      })
    },
    mounted() {
      this.isLoaded = true
    },
    components: {
      Checkbox,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      AddImage
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/blog/articles/pages/Create.vue